export default __webpack_public_path__ + "static/media/materialUI.5b2d8a0a.png";